<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ editing ? 'Sửa' : 'Xem chi tiết' }} tài khoản đơn vị đồng bộ dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              label-for="unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <label class="col-form-label">{{ syncUser.syncDataSourceName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unit"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <label class="col-form-label">{{ syncUser.unitName }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="userName"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ syncUser.userName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <!--<b-col md="6">
            <b-form-group label="Tên người dùng:"
                          label-for="userName"
                          :label-cols="3"
                          :horizontal="true"
                          label-align="right"
                          :label-class="editing? 'required' : ''">
                <b-form-input type="text" id="code" v-if="editing"
                              aria-describedby="codeFeedback"
                              v-model="$v.syncUser.userName.$model"
                              :state="$v.syncUser.userName.$dirty? !$v.syncUser.userName.$error : null">
                </b-form-input>
                <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên người dùng
                </b-form-invalid-feedback>
                <label class="col-form-label" v-if="!editing">{{ syncUser.userName }}</label>

            </b-form-group>
        </b-col>-->
                            <!--<b-col md="6">
            <b-form-group label="Email:"
                          label-for="email"
                          :label-cols="3"
                          label-align="right"
                          :horizontal="true">
                <b-form-input type="text" id="email" v-if="editing"
                              v-model="syncUser.email">
                </b-form-input>
                <label class="col-form-label" v-if="!editing">{{ syncUser.email }}</label>

            </b-form-group>
        </b-col>-->
                        </b-row>
                        <b-row v-if="editing && isAdmin">
                            <b-col md="6">
                                <b-form-group label="Mật khẩu mới:"
                                              label-for="password"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input type="password" id="password"
                                                  v-model="$v.syncUser.newPassword.$model"
                                                  @input="$v.syncUser.newPassword.$touch"
                                                  :state="$v.syncUser.newPassword.$dirty? !$v.syncUser.newPassword.$error : null">
                                    </b-form-input>
                                    <!--<b-form-invalid-feedback v-if="!$v.syncUser.passwordHash.required">
                    Vùi lòng nhập mật khẩu
                </b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="!$v.syncUser.newPassword.minLength">
                                        Mật khẩu phải có ít nhất 8 ký tự
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="$v.syncUser.newPassword.minLength && !$v.syncUser.newPassword.passwordPattern">
                                        Mật khẩu phải chứa chữ hoa, chữ thường, số và ký tự đặc biệt
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">********</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Nhập lại mật khẩu:"
                                              label-for="passwordConfirmation"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="password" id="passwordConfirmation" v-if="editing"
                                                  aria-describedby="passwordConfirmationFeedback"
                                                  v-model="$v.syncUser.passwordConfirmation.$model"
                                                  @input="$v.syncUser.passwordConfirmation.$touch"
                                                  :state="$v.syncUser.passwordConfirmation.$dirty? !$v.syncUser.passwordConfirmation.$error : null">
                                    </b-form-input>
                                    <!--<b-form-invalid-feedback v-if="!$v.syncUser.passwordConfirmation.required">
                    Vui lòng nhập lại mật khẩu
                </b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="!$v.syncUser.passwordConfirmation.sameAsPassword">
                                        Mật khẩu không khớp
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <!--<b-col md="6">
            <b-form-group label="Số điện thoại:"
                          label-for="phoneNumber"
                          :label-cols="3"
                          :horizontal="true"
                          label-align="right"
                          label-class="">
                <b-form-input type="tel" id="fullName" maxlength="20" v-if="editing"
                              v-model="syncUser.phoneNumber">
                </b-form-input>
                <label class="col-form-label" v-if="!editing">{{ syncUser.phoneNumber }}</label>

            </b-form-group>
        </b-col>-->
                            <b-col md="6">
                                <b-form-group label="Khóa tài khoản:" inline
                                              id="status"
                                              label-for="isLocked"
                                              :label-cols="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-checkbox id="isLocked" v-model="syncUser.isLocked" :disabled="!editing">
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Nhóm tài khoản:"
                                              label-for="roles"
                                              :label-cols-md="2"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-checkbox-group v-model="syncUser.roleIds" class="checkbox-group" v-if="editing">
                                        <b-form-checkbox v-for="(role, index) in listRoles" :key="role.id" :value="role.id" v-bind:style="{ width: index % 2 == 0 ? 61.5 + '%' : 'auto'}">{{ role.text }}</b-form-checkbox>
                                    </b-form-checkbox-group>
                                    <label class="col-form-label" v-if="!editing && syncUser.roleNames">{{ syncUser.roleNames.join(', ') }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="text-center">
                            <!--<b-button type="button" variant="primary" @click="edit" v-show="!editing && authorize(['ManageSyncUser'])">Sửa</b-button>-->
                            <b-button type="submit" variant="primary" v-if="editing && authorize(['ManageSyncUser'])"> Lưu</b-button>
                            <b-button type="button" variant="secondary" @click="cancel" v-if="editing && !$route.meta.editing"> Hủy</b-button>
                            <b-button type="button" variant="secondary" :to="{ path: '../' }"> Quay lại</b-button>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    const passwordPattern = helpers.regex('passwordPattern', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/)

    export default {
        name: 'SyncUserDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                syncUser: {
                },
                editing: this.$route.meta.editing,
                listRoles: []
            }
        },
        computed: {
            syncUserId() {
                return this.$route.params.syncUserId;
            },
            ...mapState({
                units: (state, getters) => getters.unitTree,
                isAdmin: (state, getters) => state.identity.username === 'admin'
            })
        },
        validations: {
            syncUser: {
                //unitId: { required },
                newPassword: { minLength: minLength(8), passwordPattern },
                passwordConfirmation: { sameAsPassword: sameAs('newPassword') },
            }
        },
        created() {
            var vm = this;
            this.$services.get('lookup/sync-roles').done((response) => vm.listRoles = response);
            this.loadSyncUserDetail();
        },
        methods: {
            loadSyncUserDetail() {
                var vm = this;
                return this.$services.get(`sync-users/${this.syncUserId}`).done(syncUser => {
                    syncUser.newPassword = "";
                    syncUser.passwordConfirmation = "";
                    vm.syncUser = syncUser;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '../' });
            },
            cancel() {
                var vm = this;
                this.loadSyncUserDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.put(`sync-users/${this.syncUserId}`, this.syncUser).done(() => {
                        vm.$toastr.s('Cập nhật tài khoản thành công');
                        vm.back();
                    });
                }
            },
        }
    }
</script>
<style scoped>
</style>
